/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionSeasonUpdate
 */
export interface CompetitionSeasonUpdate {
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeasonUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeasonUpdate
     */
    ordinal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeasonUpdate
     */
    league_id?: string | null;
}

/**
 * Check if a given object implements the CompetitionSeasonUpdate interface.
 */
export function instanceOfCompetitionSeasonUpdate(value: object): value is CompetitionSeasonUpdate {
    return true;
}

export function CompetitionSeasonUpdateFromJSON(json: any): CompetitionSeasonUpdate {
    return CompetitionSeasonUpdateFromJSONTyped(json, false);
}

export function CompetitionSeasonUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionSeasonUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'league_id': json['league_id'] == null ? undefined : json['league_id'],
    };
}

export function CompetitionSeasonUpdateToJSON(json: any): CompetitionSeasonUpdate {
    return CompetitionSeasonUpdateToJSONTyped(json, false);
}

export function CompetitionSeasonUpdateToJSONTyped(value?: CompetitionSeasonUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'league_id': value['league_id'],
    };
}

